import {
  BulkListingPriceCalculation,
  ListingPriceCalculation,
  Seating,
} from 'src/WebApiController';

import {
  ComparableListingDisplay,
  ComparableListingDisplayProps,
} from '../../ComparableListingDisplay';
import { ComparableListing } from '../ComparableListings';

export type YourAutopriceResultsDisplayProps = Pick<
  ComparableListingDisplayProps,
  'isCurrentListing' | 'shouldShowResultTypeAction'
> & {
  currentListing: ComparableListing;
  anchorListing?: ComparableListing;
  listingPriceCalc?: ListingPriceCalculation | null;
  listingPriceCalculations?: BulkListingPriceCalculation[] | null;
  comparableListings?: ComparableListing[] | null;
  isExcludingFanInventory?: boolean;
};

export const YourAutopriceResultsDisplay: React.FC<
  YourAutopriceResultsDisplayProps
> = ({
  isCurrentListing,
  shouldShowResultTypeAction,
  currentListing,
  anchorListing,
  listingPriceCalc,
  listingPriceCalculations,
  comparableListings,
  isExcludingFanInventory,
}) => {
  if (currentListing.price == null || currentListing.currencyCode == null) {
    return null;
  }

  if (anchorListing) {
    if (anchorListing.price == null || anchorListing.currencyCode == null) {
      return null;
    }
  }

  const formatterCurrent = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currentListing.currencyCode,
  });

  return (
    <ComparableListingDisplay
      listingId={currentListing.listingId}
      isOutlier={currentListing.isOutlier}
      isAnchor={currentListing.isAnchor}
      isYourListing={currentListing.isYourListing}
      isListed={currentListing.isListed}
      isSelectedWithListingGroup={currentListing.isSelectedWithListingGroup}
      isCurrentListing={isCurrentListing}
      price={formatterCurrent.format(currentListing.price)}
      unitCost={
        currentListing.unitCost
          ? formatterCurrent.format(currentListing.unitCost)
          : undefined
      }
      listingPriceCalc={listingPriceCalc}
      listingPriceCalculations={listingPriceCalculations}
      comparableListings={comparableListings}
      validPurchaseQuantities={currentListing.validPurchaseQuantities}
      listingNotes={currentListing.listingNotes}
      isExcludingFanInventory={isExcludingFanInventory}
      autoPricingResultType={currentListing.autoPricingResultType}
      autoPricingResultConstraintType={
        currentListing.autoPricingResultConstraintType
      }
      shouldShowResultTypeAction={shouldShowResultTypeAction}
      seating={
        {
          section: currentListing.section ?? '',
          row: currentListing.row ?? '',
        } as Seating
      }
    />
  );
};
